export const BlacklistedIcon = ({ color }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={color ?? 'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 6.94942 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0ZM8 14.4C6.30262 14.4 4.67475 13.7257 3.47452 12.5255C2.27429 11.3252 1.6 9.69738 1.6 8C1.59824 6.57868 2.07442 5.19804 2.952 4.08L11.92 13.048C10.802 13.9256 9.42133 14.4018 8 14.4ZM13.048 11.92L4.08 2.952C5.19804 2.07441 6.57868 1.59823 8 1.6C9.69739 1.6 11.3253 2.27428 12.5255 3.47452C13.7257 4.67475 14.4 6.30261 14.4 8C14.4018 9.42132 13.9256 10.802 13.048 11.92Z"
      fill={color ? color : '#304968'}
    />
  </svg>
)
